import React from "react";
import { useGeneralContext } from "../../context/GeneralContext";
import { Link, useHistory } from "react-router-dom";
import * as S from "./styles";

const CategoriesList = () => {
  const { categories } = useGeneralContext();
  const history = useHistory();
  const lastPage =
    (!!history.location.state && history.location.state.origin) || "/explore";

  const listItem = categories.map((category) => (
    <S.CategoryItem key={category.id}>
      <Link
        replace
        to={`/categoria/${category.id}`}
        id={`btn-categories_list-${category.title
          .toLowerCase()
          .replace(" ", "-")}`}
        name={`btn-categories_list-${category.title
          .toLowerCase()
          .replace(" ", "-")}`}
      >
        {category.title}
      </Link>
    </S.CategoryItem>
  ));

  return (
    <S.Wrapper>
      <S.HeaderContainer>
        <Link
          id={"btn-categories_list-fechar"}
          name={"btn-categories_list-fechar"}
          replace
          to={lastPage}
        >
          <i className="fas fa-times" />
        </Link>
      </S.HeaderContainer>

      <S.CategoriesList>
        <S.CategoryItem key={"btn-categories_list-inicio"}>
          <Link
            id={"btn-categories_list-inicio"}
            name={"btn-categories_list-inicio"}
            replace
            to={`/`}
          >
            <strong>Início</strong>
          </Link>
        </S.CategoryItem>
        {listItem}
      </S.CategoriesList>
    </S.Wrapper>
  );
};

export default CategoriesList;
